<mat-toolbar class="bg-white d-flex justify-content-between align-items-center main-header border-bottom">
  <div>
    <a class="brand-small-logo" routerLink="/">MERLIN</a>
    <span *ngIf="categoryName"> | </span>
    <span *ngIf="categoryName">{{categoryName}}</span>
  </div>
  <div class="main-page__search">
    <form (submit)="searchCode()" *ngIf="isSearchEnabled">
      <mat-form-field appearance="outline" class="w-100">
        <input matInput placeholder="Ask anything related to code." [formControl]="queryText">
        <button type="button" *ngIf="queryText?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <span class="material-symbols-outlined">
            close
          </span>
        </button>
      </mat-form-field>
    </form>
  </div>
  <div>
    <button mat-icon-button class="favorite-icon">
      <span class="material-symbols-outlined">
        favorite
      </span>
    </button>
    <button mat-icon-button class="example-icon">
      <span class="material-symbols-outlined">
        account_circle
      </span>
    </button>
  </div>
</mat-toolbar>
